// extracted by mini-css-extract-plugin
export default {"fav-alert":"fav-alert--14036","favAlert":"fav-alert--14036","fav-link":"fav-link--c9256","favLink":"fav-link--c9256"};